import { FC } from 'react';
import { UnifiedCutsheetBuilder } from './unified-cutsheet-builder';

/**
 * Main Cutsheet V2 Application
 *
 * Unified application that combines:
 * 1. Capabilities Builder (left column - define processor capabilities)
 * 2. Questionnaire Builder (right column - create customer-facing questionnaires with drag & drop)
 * 3. Future: Cutsheet PDF Generator
 * @returns Unified cutsheet application component
 */
export const CutsheetV2App: FC = () => <UnifiedCutsheetBuilder />;
